// extracted by mini-css-extract-plugin
export default {"root":"MultiLineColumn_root__j9Gea","name":"MultiLineColumn_name__Trsbl","no":"MultiLineColumn_no__rPlW5"};